<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_refineries')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.resourcesRefineries.eventually') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.resourcesRefineries.builtOnPlanets" tag="span">
          <template #refineryIcon><GenericIcon type="refinery"/></template>
        </i18n-t>
      </p>
      <p class="pb-2">
        {{ t('tutorial.resourcesRefineries.costCredits') }}
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        {{ t('common.actions.understood') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>